import React from 'react';
import { isNativeIosApp } from '../../../utils/nativePlatform';
import Subscribe from './Subscribe';
import SubscriptionUnavailable from './SubscriptionUnavailable';

const SubscriptionEntry = () => (
  isNativeIosApp() ? <SubscriptionUnavailable /> : <Subscribe />
);

export default SubscriptionEntry;
